'use strict';

angular.module('ClinicApp').directive('timeslotsCalendar', function(OpencareConstants, ReservedAppointmentSlotService, ProviderAvailabilityBlockService, $timeout, $state, $document, OCDomUtil, $q, OCPhotoUtil, CurrentUser) {
  return {
    templateUrl: '/views/directives/_timeslots-calendar.html',
    scope: {
      data: '=timeslotsCalendar',
      appointmentTimeSlotsData: '=',
      availabilityBlocks: '=',
      filters: '=',
      onReload: '&',
      clinic: '=',
      modelType: '=',
      mobile: '@',
      reservedSlotProviders: '=',
    },
    link: function($scope, element) {
      const CALENDAR_DAYS_NUM = $scope.mobile ? 1 : 7;
      const CALENDAR_INDICATOR_OFFSET = 6; // MUST MATCH .dot (border-radius) IN THE CSS
      const SLOT_DURATION_DEFAULT = 30;
      const EVENT_CSS_OUTER_CELL_HEIGHT_PX = 50;
      const EVENT_CSS_OUTER_CELL_WIDTH_SMALL_PX = 40; // MUST MATCH .cell-small IN THE CSS.
      const EVENT_CSS_OUTER_PADDING_PX = 4;
      const EVENT_CSS_OUTER_CELL_HEIGHT_TO_MINUTES_RATIO = EVENT_CSS_OUTER_CELL_HEIGHT_PX / SLOT_DURATION_DEFAULT;
      const EVENT_CSS_WIDTH_PCT = 95; // MUST MATCH .calendar-event-outer IN THE CSS.
      const EVENT_CSS_MIN_DRAG_DISTANCE_PX = 4;

      // Metadata keys stamped by the back-end tasks that create availability blocks:
      // the Instant Book slots generation job and the manual IB experiment task.
      // A block carrying none of these was authored by the practice or an admin.
      const SYSTEM_BLOCK_METADATA_KEYS = ['instantBookSlotsGeneration', 'manualIBExperiment'];

      const scrollBarWidth = OCDomUtil.getScrollbarWidth();
      let eventMouseDownPosition;
      const elementsCache = {};

      $scope.isClinic = $scope.modelType === 'clinic';
      $scope.idSuffix = $scope.mobile ? '-mobile' : '';
      $scope.filteredBlocks = [];
      $scope.newEventOptions = {
        available: true,
        recurring: false,
        vacation: false,
        provider: $scope.filters.provider,
      };

      $scope.primaryPhotoForModel = OCPhotoUtil.primaryPhotoForModel;
      $scope.clinicTimezone = CurrentUser.getClinics().find((c) => c.id === $scope.clinic.id).timezone;

      function setFullHeight() {
        var mainViewEl = getElement($scope.isClinic ? '#clinic-view' : '#doctor-view', true);
        var scrollAreaEl = getElement('#js-calendar-scroll-area', true);

        if (mainViewEl.length && scrollAreaEl.length) {
          var calendarHeight = scrollAreaEl.outerHeight() - 25;
          var heightDifference = mainViewEl.outerHeight() - calendarHeight;

          scrollAreaEl.css({
            height: 'calc(100vh - ' + heightDifference + 'px)',
          });
        }
      }

      $scope.$watch('data', function() {
        var allSlots = $scope.data.reservedAppointmentSlots || [];

        if ($scope.appointmentTimeSlotsData) {
          _.each($scope.appointmentTimeSlotsData, function(appointmentSlot) {
            appointmentSlot.id = appointmentSlot.id
              || appointmentSlot.reservedAppointmentSlot
              || appointmentSlot.appointmentId;

            var isAppointmentSlot = !!_.find(allSlots, function(slot) {
              return slot.id === appointmentSlot.reservedAppointmentSlot
                || slot.appointmentId === appointmentSlot.appointmentId;
            });

            if (!isAppointmentSlot) {
              _.remove(allSlots, function(slot) {
                return slot.id === appointmentSlot.reservedAppointmentSlot
                  || slot.appointmentId === appointmentSlot.appointmentId;
              });
              allSlots.push(appointmentSlot);
            }
          });
        }

        $scope.slots = _.reject(allSlots, function(slot) {
          var lastDate = moment($scope.filters.dateGte).add(CALENDAR_DAYS_NUM, 'days');

          return moment(slot.date).isAfter(lastDate);
        });

        $scope.slots = _.map($scope.slots, function(slot) {
          slot.displayId = slot.id || slot.appointmentId;
          slot.hasAppointment = !!(slot.appointmentId || slot.appointment);

          return slot;
        });

        $scope.slots = _.filter($scope.slots, function(slot) {
          var slotDatetime = moment(slot.date).add(slot.time, 'minutes');

          return !_.some($scope.filteredBlocks, function(block) {
            // Check that the slot and block have the same provider before filtering out
            var slotProviderId = _.get(slot, 'provider.id', slot.provider);
            var blockProviderId = _.get(block, 'provider.id', block.provider);

            if (slotProviderId && blockProviderId && slotProviderId !== blockProviderId) {
              return false;
            }

            var sameDayOfWeek = slotDatetime.day() === moment(block.startDate, OpencareConstants.apiDateFormat).day();
            var slotMinutes = slotDatetime.hour() * 60 + slotDatetime.minute();

            return !block.available
              && sameDayOfWeek
              && slotMinutes >= block.startTime - 15
              && slotMinutes < block.endTime;
          });
        });

        $scope.slots = _.uniq($scope.slots, function(slot) {
          var provider = _.get(slot.provider, 'id', slot.provider);
          return [provider, slot.time, slot.date, slot.status].join('-');
        });

        var slotsByDayDict = _.groupBy($scope.slots, 'date');

        $scope.slotsByDay = _.times(CALENDAR_DAYS_NUM, function(i) {
          var dayString = moment($scope.filters.dateGte).add(i, 'day')
            .format(OpencareConstants.apiDateFormat);
          return slotsByDayDict[dayString] || [];
        });

        repositionEvents();
        scrollToEvents();
      });

      $scope.$watch('availabilityBlocks', function() {
        resetAvailabilityBlocks();
        repositionEvents();
        scrollToEvents();
      });

      function resetAvailabilityBlocks() {
        function nextDayOfWeek(startDate, dayOfWeek) {
          var isoWeekday = startDate.isoWeekday();

          if (isoWeekday <= dayOfWeek) {
            return startDate.isoWeekday(dayOfWeek);
          } else {
            return startDate.add(1, 'weeks').isoWeekday(dayOfWeek);
          }
        }

        $scope.filteredBlocks = _.filter($scope.availabilityBlocks, function(availabilityBlock) {
          if (!availabilityBlock.recurring) {
            return availabilityBlock.startDate >= $scope.filters.dateGte
              && availabilityBlock.startDate < $scope.filters.dateLt;
          } else {
            var blockDate = moment(availabilityBlock.startDate);
            var filterDateGte = moment($scope.filters.dateGte);
            var filterDateLt = moment($scope.filters.dateLt);

            if (blockDate.isSameOrAfter(filterDateLt)) {
              return false;
            }

            var laterDate;

            if (blockDate.isSameOrBefore(filterDateGte)) {
              laterDate = filterDateGte;
            } else {
              laterDate = blockDate;
            }

            var blockOccurrence = nextDayOfWeek(laterDate, blockDate.day());
            availabilityBlock._date = blockOccurrence.format(OpencareConstants.apiDateFormat);

            // Make sure there are no block exceptions, appointments, or slots on this date.
            const hasException = (availabilityBlock.exceptions || []).some((exception) => {
              return exception.date === blockOccurrence.format(OpencareConstants.apiDateFormat);
            });
            var hasAppointmentSlot = ($scope.appointmentTimeSlotsData || []).some((appointmentSlot) => {
              return appointmentSlot.provider.id === (availabilityBlock.provider?.id || availabilityBlock.provider)
                && appointmentSlot.date === blockOccurrence.format(OpencareConstants.apiDateFormat)
                && appointmentSlot.time === availabilityBlock.startTime;
            });
            const hasSlot = ($scope.slots || []).some((slot) => {
              return slot.provider.id === (availabilityBlock.provider?.id || availabilityBlock.provider)
                && slot.date === blockOccurrence.format(OpencareConstants.apiDateFormat)
                && slot.time === availabilityBlock.startTime;
            });

            return !hasException && !hasAppointmentSlot && !hasSlot;
          }
        });

        $scope.filteredBlocks = _.uniq($scope.filteredBlocks, function(block) {
          var provider = _.get(block.provider, 'id', block.provider);
          return [provider, block.startTime, block.endTime, block._date ?? block.startDate, block.available, block.type].join('-');
        });

        var unavailableBlocks = _.filter($scope.filteredBlocks, function(block) {
          return block.available === false;
        });
        var availableBlocks = _.filter($scope.filteredBlocks, function(block) {
          return block.available === true;
        });

        // This filter assumes blocks are 30 minutes, which may not be true in the future.
        availableBlocks = _.filter(availableBlocks, function(block) {
          var startDatetime = moment(block.startDate).add(block.startTime, 'minutes');

          // This logic hides the availability blocks when it detects that an unavailable block exists at that same time.
          // We want this to only work if it's the same provider.
          return !_.some(unavailableBlocks, function(unavailableBlock) {
            if (_.get(unavailableBlock, 'provider.id') && unavailableBlock.provider.id !== block.provider.id) {
              return false;
            }

            var sameDayOfWeek = startDatetime.day() === moment(
              unavailableBlock.startDate,
              OpencareConstants.apiDateFormat,
            ).day();
            var startMinutes = startDatetime.hour() * 60 + startDatetime.minute();

            return sameDayOfWeek
              && startMinutes >= unavailableBlock.startTime - 15
              && startMinutes < unavailableBlock.endTime;
          });
        });

        $scope.availableBlocksByDay = _.groupBy(availableBlocks, function(block) {
          return moment(block.startDate).day();
        });
        $scope.unavailableBlocksByDay = _.groupBy(unavailableBlocks, function(block) {
          return moment(block.startDate).day();
        });

        $scope.blocksByDayOffset = moment($scope.filters.dateGte).day();
      }

      function getElement(selector, noSuffix) {
        selector = selector + (noSuffix === true ? '' : $scope.idSuffix);
        var element = elementsCache[selector];

        if (!element) {
          element = angular.element(selector);
          elementsCache[selector] = element;
        }

        return element;
      }

      // Given an $event, position the "+ Add Slot" box
      function positionAddCalendarEventFromEvent(e) {
        if (!dayEls) {
          return;
        }

        var addSlot = getElement('#js-calendar-add');
        var css = {};
        var slotMoment = coordinateToMoment(e.pageX, e.pageY);

        if (!slotMoment) {
          // The mouse is outside of the grid, so hide the Add Slot box
          css.display = 'none';
          $scope.addEventMoment = null;
        } else {
          css.display = 'block';

          // The mouse is inside the grid, so check if it in a spot where a slot can be added
          if (isValidAddMoment(slotMoment, undefined)) {
            // The slot can be added here, so position the Add Slot box
            $scope.addEventMoment = slotMoment;
            css = _.merge(momentToAddSlotCSS(slotMoment), css);
          } else {
            css.display = 'none';
          }
        }

        addSlot.css(css);
      }

      // Finds the move object
      // Converts the mouse x y to a moment object.
      //  If this moment object is not valid, it shows the slot in its original positon.
      //  Otherwise, it moves the slot to the position.
      function positionDraggingEventFromEvent(e) {
        var eventType = $scope.getDraggingEventType();
        if (eventType === 'slot') {
          var slotEvent = getElement('#js-calendar-slot-move');
          var slotMoment = coordinateToMoment(e.pageX, e.pageY);

          if (!slotMoment) {
            // If the slot is being dragged to an invalid position, set it to its original position
            $scope.moveSlotMoment = slotToMoment($scope.draggingEvent);
            slotEvent.css(momentToAddSlotCSS($scope.moveSlotMoment));
          } else {
            if (isValidAddMoment(slotMoment, $scope.draggingEvent)) {
              $scope.moveSlotMoment = slotMoment;
              slotEvent.css(momentToAddSlotCSS($scope.moveSlotMoment));
            }
          }
        } else if (eventType === 'available-block' || eventType === 'unavailable-block') {
          var availability = eventType === 'available-block' ? 'available' : 'unavailable';

          var blockEvent = getElement('#js-calendar-' + availability + '-block-move');
          var blockMoment = coordinateToMoment(e.pageX, e.pageY);
          var length = $scope.draggingEvent.endTime - $scope.draggingEvent.startTime;
          if (!blockMoment) {
            $scope.moveSlotMoment = blockToMoment($scope.draggingEvent);
            blockEvent.css(momentToAddSlotCSS($scope.moveSlotMoment));
          } else {
            var blockEndTime = moment(blockMoment).add(length, 'minutes');
            if (isValidAddMomentBlock(blockMoment, blockEndTime, $scope.draggingEvent)) {
              $scope.moveSlotMoment = blockMoment;
              moveSlotForBlock($scope.moveSlotMoment, availability, length);
            }
          }
        }
      }

      function moveSlotForBlock(m, availability, length) {
        var blockEvent = getElement('#js-calendar-' + availability + '-block-move');
        var hour = m.hour();
        var hourEl = hourEls[hour];
        var minutePct = m.minutes() / 60;
        var minutePixels = hourEl.height() * minutePct;
        var dayEl = getElement('#js-calendar-day-' + m.day());
        var scrollArea = getElement('#js-calendar-scroll-area');
        var dayIndex = getDayIndex(m.day());
        var slotContainerDayCell = getElement('#js-calendar-event-container').find('.day-cell')
          .eq(dayIndex);

        var blockCss = {
          top: Math.floor(hourEl.offset().top)
            + minutePixels
            + scrollArea.scrollTop()
            - Math.floor(scrollArea.offset().top) + 1,
          left: Math.floor(dayEl.offset().left) - Math.floor(scrollArea.offset().left) + 1,
          width: slotContainerDayCell.width(),
        };

        blockEvent.css(blockCss);

        var childSlotEl = getElement('#js-calendar-' + availability + '-block-move .calendar-event');

        var childSlotElCss = {
          height: EVENT_CSS_OUTER_CELL_HEIGHT_TO_MINUTES_RATIO * length - EVENT_CSS_OUTER_PADDING_PX,
        };

        childSlotEl.css(childSlotElCss);
      }

      $scope.setAvailability = function(value) {
        $scope.newEventOptions.available = value;
      };

      $scope.setRecurring = function(value) {
        $scope.newEventOptions.recurring = value;
      };

      $scope.setVacation = function(value) {
        $scope.newEventOptions.vacation = value;
      };

      $scope.resizeBlock = function(e) {
        eventMouseDownPosition = eventMouseDownPosition || {
          x: e.pageX,
          y: e.pageY,
        };
        $scope.draggingEvent = this.block;
        $scope.resizingBlock = true;
      };

      $scope.getDraggingEventType = function() {
        return $scope.getEventType($scope.draggingEvent);
      };

      $scope.getEventType = function(event) {
        if (!event) {
          return;
        }

        if (event.time !== undefined && event.time !== null) {
          return 'slot';
        } else if (event.startTime && event.available) {
          return 'available-block';
        } else if (event.startTime && !event.available) {
          return 'unavailable-block';
        }
      };

      function clearDragSlot(e) {
        var type = $scope.getDraggingEventType();
        if (type) {
          hideAddEvent();
          getElement('#js-calendar-' + type + '-' + $scope.draggingEvent.id).show();
        }
        if (e) {
          positionAddCalendarEventFromEvent(e);
        }
        $scope.draggingEvent = null;
        eventMouseDownPosition = null;
      }

      function mobileScrollAreaClick(e) {
        if (!$scope.addEventMoment) {
          positionAddCalendarEventFromEvent(e);
        } else {
          var slotMoment = coordinateToMoment(e.pageX, e.pageY);
          if (slotMoment.isSame($scope.addEventMoment)) {
            createSlotFromEvent(e);
          } else {
            positionAddCalendarEventFromEvent(e);
          }
        }
      }

      $scope.showRecurringPrompt = false;

      function shouldCreateEvent(e) {
        var addEventMoment = coordinateToMoment(e.pageX, e.pageY);

        if (!addEventMoment || !isValidAddMoment(addEventMoment, undefined)) {
          return false;
        }
        return true;
      }

      function showingUserPrompt() {
        return $scope.showRecurringPrompt || $scope.showDeletePrompt;
      }

      function scrollAreaMouseUp(e) {
        if (showingUserPrompt()) {
          return;
        }
        if ($scope.resizingBlock && eventMouseDownPosition) {
          var event = _.assign({}, $scope.draggingEvent);
          var coordinateMomentObject = coordinateToMoment(e.pageX, e.pageY);
          var newEndTime = coordinateMomentObject.hour() * 60 + coordinateMomentObject.minutes();

          $scope.resizingBlock = false;
          eventMouseDownPosition = null;
          $scope.draggingEvent = null;

          var length = Math.max(SLOT_DURATION_DEFAULT, newEndTime - event.startTime, SLOT_DURATION_DEFAULT);
          var momentObj = moment(event.startDate).add(event.startTime, 'minutes');
          createAvailabilityBlock(momentObj, false, event.available, length);

          if (event.recurring) {
            $scope.createAvailabilityBlockException(event);
          } else {
            $scope.removeAvailabilityBlock(event, e);
          }
        } else if ($scope.draggingEvent) {
          releaseDragTimeslot(e);
        } else if (shouldCreateEvent(e) || $scope.filters.provider === OpencareConstants.allProviders) {
          $scope.newEventOptions.startTime = coordinateToMoment(e.pageX, e.pageY)?.toDate();
          $scope.newEventOptions.endTime = coordinateToMoment(e.pageX, e.pageY)
            ?.add(SLOT_DURATION_DEFAULT, 'minutes')
            ?.toDate();
          $scope.showRecurringPrompt = true;
          $scope.mouseUpEvent = e;
        }
      }

      $scope.hidePrompts = function() {
        $scope.showRecurringPrompt = false;
        $scope.showDeletePrompt = false;
        $scope.newEventOptions = {
          available: true,
          recurring: false,
          provider: $scope.filters.provider,
        };
      };

      $scope.createCalendarEvent = function() {
        $q.when().then(function() {
          if ($scope.calendarEventIsCreating) {
            return $q.reject();
          }

          $scope.calendarEventIsCreating = true;
          var event = _.assign({}, $scope.mouseUpEvent);
          $scope.mouseUpEvent = undefined;

          var date;
          var startTime = moment($scope.newEventOptions.startTime);

          if ($scope.draggingEvent) {
            return releaseDragTimeslot(event);
          } else if (!$scope.newEventOptions.available && $scope.newEventOptions.vacation) {
            date = coordinateToMoment(event.pageX, event.pageY).format(OpencareConstants.apiDateFormat);
            return createAvailabilityBlockOfVacationType(date);
          } else if ($scope.newEventOptions.available && !$scope.newEventOptions.recurring) {
            return createSlot(startTime).then(hideAddEvent);
          } else {
            date = coordinateToMoment(event.pageX, event.pageY).format(OpencareConstants.apiDateFormat);
            var endTime = moment($scope.newEventOptions.endTime);
            var length = moment.duration(endTime.diff(startTime)).asMinutes();
            var momentObj = moment(date + ' ' + startTime.format('HH:mm'), 'YYYY-MM-DD HH:mm');
            return createAvailabilityBlock(
              momentObj,
              $scope.newEventOptions.recurring,
              $scope.newEventOptions.available,
              length,
            );
          }
        })
          .then(function() {
            $scope.hidePrompts();
          })
          .finally(function() {
            $scope.calendarEventIsCreating = false;
          });
      };

      $scope.scrollAreaClick = $scope.mobile && mobileScrollAreaClick;
      $scope.scrollAreaMouseUp = $scope.mobile || scrollAreaMouseUp;

      $scope.scrollAreaMouseMove = $scope.mobile || function(e) {
        if (showingUserPrompt()) {
          return;
        } else if ($scope.resizingBlock) {
          resizeEvent(this.draggingEvent, e);
        } else if ($scope.draggingEvent) {
          positionDraggingEventFromEvent(e);
        } else {
          positionAddCalendarEventFromEvent(e);
        }
      };

      function docReleaseClearDrag() {
        clearDragSlot();
        getElement('#js-calendar-' + $scope.getDraggingEventType() + '-move').show();
        $document.off('mouseup', docReleaseClearDrag);
      }

      $scope.scrollAreaMouseLeave = $scope.mobile || function() {
        if (showingUserPrompt()) {
          return;
        }
        if ($scope.draggingEvent) {
          if ($scope.draggingEvent.slot) {
            getElement('#js-calendar-slot-' + $scope.draggingEvent.id).show();
            getElement('#js-calendar-slot-move').hide();
          } else if ($scope.draggingEvent.block) {
            var available = $scope.draggingEvent.block.available ? 'available' : 'unavailable';
            getElement('#js-calendar-block-' + available + '-' + $scope.draggingEvent.id).show();
            getElement('#js-calendar-block-' + available + '-move').hide();
          }
        }
        $document.on('mouseup', docReleaseClearDrag);
        hideAddEvent();
      };

      $scope.scrollAreaMouseEnter = $scope.mobile || function() {

        if ($scope.draggingEvent) {
          getElement('#js-calendar-slot-' + $scope.draggingEvent.id).hide();
          getElement('#js-calendar-slot-move').show();
          $document.off('mouseup', docReleaseClearDrag);
        }
      };

      $scope.eventMouseDown = $scope.mobile || function(e) {

        if (e.button === 2) { // Ignore right clicks
          e.stopPropagation();
          return;
        }
        if ($scope.draggingEvent || (this.slot && this.slot.status != 'OPEN')) {
          return;
        }
        eventMouseDownPosition = {
          x: e.pageX,
          y: e.pageY,
        };
      };

      function getDistance(p1, p2) {
        return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
      }

      function resizeEvent(calendarEvent, angularEvent) {
        var dragCoordinateMomentObject = coordinateToMoment(angularEvent.pageX, angularEvent.pageY);
        var numMinutes = dragCoordinateMomentObject.hour() * 60 + dragCoordinateMomentObject.minutes();

        var availability = calendarEvent.available ? 'available' : 'unavailable';
        var childSlotEl = getElement('#js-calendar-' + availability + '-block-' + calendarEvent.id + ' .calendar-event');

        var baseLength = EVENT_CSS_OUTER_CELL_HEIGHT_TO_MINUTES_RATIO * (numMinutes - calendarEvent.startTime);
        var newHeight = Math.max(
          EVENT_CSS_OUTER_CELL_HEIGHT_PX,
          Math.round(baseLength / SLOT_DURATION_DEFAULT * SLOT_DURATION_DEFAULT),
        ) - EVENT_CSS_OUTER_PADDING_PX;

        childSlotEl.css({
          height: newHeight,
        });
      }

      $scope.eventMouseLeave = $scope.eventMouseMove = $scope.mobile || function(e) {

        if (showingUserPrompt()) {
          return;
        }
        hideAddEvent();
        if ($scope.draggingEvent || !eventMouseDownPosition || (this.slot && this.slot.status != 'OPEN')) {
          return;
        }

        if ($scope.resizingBlock) {
          return;
        }

        var p2 = {
          x: e.pageX,
          y: e.pageY,
        };
        var distance = getDistance(eventMouseDownPosition, p2);
        if (distance >= EVENT_CSS_MIN_DRAG_DISTANCE_PX) {
          $scope.draggingEvent = _.assign({}, this.slot || this.block);
          getElement(e.currentTarget, true).hide();
          positionDraggingEventFromEvent(e);
        }
      };

      $scope.eventMouseUp = $scope.mobile || function(e) {
        if (!eventMouseDownPosition || $scope.resizingBlock) {
          return;
        }
        var p2 = {
          x: e.pageX,
          y: e.pageY,
        };
        var distance = getDistance(eventMouseDownPosition, p2);
        if (distance < EVENT_CSS_MIN_DRAG_DISTANCE_PX || $scope.resizingBlock) {
          // Mouse hasn't moved far enough, consider this a click not a drag.
          eventMouseDownPosition = null;
        }
      };

      // Start with add slot hidden.
      $timeout($scope.scrollAreaMouseLeave);

      // For switching between mobile and desktop.
      var $window = angular.element(window);
      var resizeHandler = _.debounce(function() {
        repositionEvents();
      }, 500);

      $window.on('resize', resizeHandler);
      $scope.$on('$destroy', function() {
        $window.off('resize', resizeHandler);
      });

      var hourEls,
        dayEls;
      $timeout(function() {
        hourEls = _.map($scope.hours, function(hour) {
          return getElement('#js-calendar-hour-' + hour.hour());
        });

        dayEls = _.map($scope.days, function(day) {
          return getElement('#js-calendar-day-' + day.day());
        });
      });

      function coordinateToMoment(x, y) {
        var firstDay = _.first(dayEls);
        var lastDay = _.last(dayEls);
        if (!firstDay || !lastDay) {
          // Component is still loading
          return;
        }

        if (x < firstDay.offset().left || x > lastDay.offset().left + lastDay.width()) {
          // If you're outside of the grid
          return null;
        }

        // Get the day before the x coordinate
        var dayIndex = _.findLastIndex(dayEls, function(el) {
          return x > el.offset().left;
        });

        // Get the hour before the y coordinate
        var hour = _.findLastIndex(hourEls, function(el) {
          return y > el.offset().top;
        });
        hour = Math.max(hour, 0);
        var hourEl = hourEls[hour];
        var minuteDeltaPixels = y - hourEl.offset().top;
        var minuteDeltaPct = minuteDeltaPixels / hourEl.height();
        // Floor to nearest 25% (i.e. 15 minutes)
        minuteDeltaPct = (Math.floor(minuteDeltaPct * 4) / 4).toFixed(2);
        var minuteDeltaMinutes = Math.min(minuteDeltaPct * 60, hour === 23 ? SLOT_DURATION_DEFAULT : 45); // Limit to 11:30pm

        return moment($scope.days[dayIndex])
          .hour(hour)
          .minute(minuteDeltaMinutes);
      }

      function getDayIndex(weekDayIndex) {
        return _.findIndex($scope.days, function(day) {
          return day.day() === weekDayIndex;
        });
      }

      function momentToAddSlotCSS(m) {
        var hour = m.hour();
        var hourEl = hourEls[hour];
        var minutePct = m.minutes() / 60;
        var minutePixels = hourEl.height() * minutePct;
        var dayEl = getElement('#js-calendar-day-' + m.day());
        var scrollArea = getElement('#js-calendar-scroll-area');
        var dayIndex = getDayIndex(m.day());
        var slotContainerDayCell = getElement('#js-calendar-event-container').find('.day-cell')
          .eq(dayIndex);

        return {
          top: Math.floor(hourEl.offset().top)
            + minutePixels
            + scrollArea.scrollTop()
            - Math.floor(scrollArea.offset().top)
            + 1,
          left: Math.floor(dayEl.offset().left) - Math.floor(scrollArea.offset().left) + 1,
          width: slotContainerDayCell.width(),
        };
      }

      function slotToMoment(slot) {
        return moment(slot.date).minutes(slot.time);
      }

      function blockToMoment(block) {
        var dayOfWeek = moment(block.startDate).day();
        var momentObject = moment($scope.filters.dateGte).day(dayOfWeek)
          .startOf('day');
        if (momentObject.isAfter(momentObject.day(dayOfWeek))) {
          return momentObject.add(1, 'week');
        }
        return momentObject.add(block.startTime, 'minutes');
      }

      function isValidAddMomentBlock(startMoment, endMoment, ignoreEvent) {

        if (!startMoment || !endMoment) {
          return false;
        }

        var noSlotIntersections = !_.some($scope.slots, function(slot) {
          if (ignoreEvent && ignoreEvent.time && slot.id == ignoreEvent.id) {
            return;
          }
          var slotMoment = slotToMoment(slot);
          return slotMoment.isBetween(startMoment, endMoment, 'minute', '[)')
            || slotMoment.add(29, 'minutes').isBetween(startMoment, endMoment, 'minute', '[)');
        });

        var noBlockIntersections = !_.some($scope.filteredBlocks, function(block) {
          if (ignoreEvent && ignoreEvent.startTime && block.id == ignoreEvent.id) {
            return;
          }
          var sameDayOfWeek = startMoment.day() === moment(block.startDate, OpencareConstants.apiDateFormat).day();
          var blockMoment = blockToMoment(block);
          var blockEndMoment = moment(blockMoment).add(block.endTime - block.startTime, 'minutes');

          var intervalsOverlap = blockMoment.isBetween(startMoment, endMoment)
            || blockEndMoment.isBetween(startMoment, endMoment)
            || startMoment.isBetween(blockMoment, blockEndMoment)
            || endMoment.isBetween(blockMoment, blockEndMoment)
            || blockMoment.isSame(startMoment)
            || blockEndMoment.isSame(endMoment);

          return sameDayOfWeek && intervalsOverlap;
        });

        return noSlotIntersections && noBlockIntersections;
      }

      /**
       * Scrolls the calendar view to the earliest events or to the clinic start hours.
       */
      var previousScrollToHour = 0; // Using this to store previously scrolled to hour so that it doesnt run multiple times
      function scrollToEvents() {
        $timeout(function() {
          var scrollToTime;

          // Scroll to the earliest slot or availability block.
          if ($scope.slots && $scope.slots.length) {
            var earliestSlot = _.chain($scope.slots).filter(function(slot) {
              return slot.date >= $scope.filters.dateGte;
            })
              .min(function(slot) {
                return slot.time;
              })
              .value();
            scrollToTime = scrollToTime === undefined ? earliestSlot.time : Math.min(earliestSlot.time, scrollToTime);
          }
          if ($scope.filteredBlocks && $scope.filteredBlocks.length) {
            var earliestAvailabilityBlock = _.chain($scope.filteredBlocks).filter(function(availabilityBlock) {
              return availabilityBlock._date >= $scope.filters.dateGte;
            })
              .min(function(availabilityBlock) {
                return availabilityBlock.startTime;
              })
              .value();
            scrollToTime = scrollToTime === undefined
              ? earliestAvailabilityBlock.startTime
              : Math.min(earliestAvailabilityBlock.startTime, scrollToTime);
          }

          // Scroll to the clinic hours.
          if (scrollToTime === undefined) {
            var earliestClinicHoursItem = _.chain($scope.clinic.hours).filter(function(hoursItem) {
              return hoursItem.start < hoursItem.end;
            })
              .min(function(hoursItem) {
                return hoursItem.start;
              })
              .value();

            if (earliestClinicHoursItem) {
              scrollToTime = earliestClinicHoursItem.start;
            }
          }

          var scrollAreaEl = getElement('#js-calendar-scroll-area');

          if (scrollToTime !== undefined) {
            var scrollToHour = moment().startOf('year')
              .add(scrollToTime, 'minutes')
              .hour();
            if (scrollToHour === previousScrollToHour) {
              return;
            }
            var headerEl = getElement('#js-calendar-header');
            var hourEl = getElement('#js-calendar-hour-' + scrollToHour);
            var scrollMarginTop = EVENT_CSS_OUTER_CELL_HEIGHT_PX * 2;
            var scrollTo = hourEl.offset().top - headerEl.offset().top - scrollMarginTop;

            scrollAreaEl.scrollTop(scrollTo);
            previousScrollToHour = scrollToHour;
          } else {
            scrollAreaEl.scrollTop(0);
          }

          setFullHeight();
        });
      }

      // Checks if the object intersects with any availability blocks
      // Or if it intersects with any other slots
      // If it does, returns false.
      function isValidAddMoment(m, ignoreEvent) {
        if (!m) {
          return false;
        }

        var noSlotIntersections = !_.some($scope.slots, function(slot) {
          if (ignoreEvent && ignoreEvent.time && slot.id == ignoreEvent.id) {
            return;
          }
          var slotMoment = slotToMoment(slot);
          var invalidRangeStart = slotMoment.clone().subtract(15, 'minutes');
          var invalidRangeEnd = slotMoment.clone().add(SLOT_DURATION_DEFAULT, 'minutes');
          return m.isBetween(invalidRangeStart, invalidRangeEnd, 'minute', '[)');
        });

        var noBlockIntersections = !_.some($scope.filteredBlocks, function(block) {
          if (ignoreEvent && ignoreEvent.startTime && block.id == ignoreEvent.id) {
            return;
          }
          var sameDayOfWeek = m.day() === moment(block.startDate, OpencareConstants.apiDateFormat).day();
          var minutes = m.hour() * 60 + m.minute();
          return sameDayOfWeek && minutes >= block.startTime - 15 && minutes < block.endTime;
        });

        return noSlotIntersections && noBlockIntersections;
      }

      /**
       * Runs positioning of events (slots and availability blocks) in the calendar view.
       *
       * @param date - run only for specific date (YYYY-MM-DD).
       */
      function repositionEvents(date) {
        _.each($scope.slots, function(slot) {
          if (!date || slot.date === date) {
            positionSlot(slot);
          }
        });

        _.each($scope.filteredBlocks, function(availabilityBlock) {
          if (!date || availabilityBlock._date === date || availabilityBlock.startDate === date) {
            positionAvailabilityBlock(availabilityBlock);
          }
        });
      }

      /**
       * Detects if the given slot or availability block (entity) has other concurrent events
       * and calculates their position among others.
       *
       * TODO: this operation may be too heavy for the frequent calls
       * so find a way to optimize it using cached values.
       */
      function getConcurrencyData(slotOrAvailabilityBlock) {
        var date = slotOrAvailabilityBlock.date || slotOrAvailabilityBlock._date || slotOrAvailabilityBlock.startDate;
        var startTime = slotOrAvailabilityBlock.time;
        startTime = _.isNumber(startTime) ? startTime : slotOrAvailabilityBlock.startTime;
        var endTime = slotOrAvailabilityBlock.endTime;
        endTime = _.isNumber(endTime) ? endTime : startTime + SLOT_DURATION_DEFAULT;

        // Find concurrent Availability Blocks for the given time range.
        var concurrentAvailabilityBlocks = _.chain($scope.filteredBlocks).filter(function(availabilityBlock) {
          // Filter by date.
          return availabilityBlock._date === date || availabilityBlock.startDate === date;
        })
          .filter(function(availabilityBlock) {
          // Filter by time.
            return (
              (availabilityBlock.startTime <= startTime && availabilityBlock.endTime >= endTime)
              || (
                availabilityBlock.startTime < startTime
                && availabilityBlock.endTime > startTime && availabilityBlock.endTime <= endTime
              ) || (
                availabilityBlock.endTime > endTime && availabilityBlock.startTime >= startTime
                && availabilityBlock.startTime < endTime
              ) || (
                availabilityBlock.startTime >= startTime
                && availabilityBlock.endTime <= endTime
              )
            );
          })
          .each(function(availabilityBlock) {
            availabilityBlock._startTime = availabilityBlock.startTime;
            availabilityBlock._duration = availabilityBlock.endTime - availabilityBlock.startTime;
            availabilityBlock._entityType = 'AvailabilityBlock';

            if (!availabilityBlock.provider.id) {
              availabilityBlock.provider = $scope.clinic.providers.find((p) => p.id === availabilityBlock.provider);
            }
          })
          .value();

        // Find concurrent Slots for the given time range.
        var concurrentSlots = _.chain($scope.slots).filter(function(slot) {
          // Filter by date.
          return slot.date === date;
        })
          .filter(function(slot) {
          // Filter by time.
            var slotEndTime = slot.time + SLOT_DURATION_DEFAULT;

            return (
              (slot.time <= startTime && slotEndTime >= endTime)
              || (slot.time < startTime && slotEndTime > startTime && slotEndTime <= endTime)
              || (slotEndTime > endTime && slot.time >= startTime && slot.time < endTime)
              || (slot.time >= startTime && slotEndTime <= endTime)
            );
          })
          .each(function(slot) {
            slot._startTime = slot.time;
            slot._duration = SLOT_DURATION_DEFAULT;
            slot._entityType = 'Slot';
          })
          .value();

        // Calculate the index (horizontal position) of each entity.
        var entities = _.chain(concurrentAvailabilityBlocks.concat(concurrentSlots)).sortBy(function(entity) {
          return [
            24 * 60 - entity._duration, // entities with longer duration go first.
            entity._startTime, // earlier entities go first.
            entity._entityType,
            entity.id,
          ].join('_');
        })
          .each(function(entity, index) {
            entity._index = index;
          })
          .value();

        // Count the number of crossed entities.
        var crossedEntitiesCount = _.chain(entities).map('_startTime')
          .map(function(entityStartTime) {
            return _.filter(entities, function(entity) {
              return entityStartTime >= entity._startTime && entityStartTime < entity._startTime + entity._duration;
            }).length;
          })
          .max()
          .value();

        return {
          entities: entities,
          count: entities.length,
          crossedCount: crossedEntitiesCount,
          index: _.chain(entities).find({
            id: slotOrAvailabilityBlock.id,
          })
            .get('_index', 0)
            .value(),
        };
      }

      $scope.getOffsetCellWidth = function() {
        return {
          width: EVENT_CSS_OUTER_CELL_WIDTH_SMALL_PX - scrollBarWidth,
        };
      };

      $scope.days = _.times(CALENDAR_DAYS_NUM, function(i) {
        return moment($scope.filters.dateGte).add(i, 'day');
      });

      $scope.hours = _.times(24, function(i) {
        return moment().hour(i)
          .minute(0);
      });

      $scope.isWeekend = function(dayMoment) {
        return _.includes([0, 6], dayMoment.day());
      };

      $scope.isToday = function(dayMoment) {
        return dayMoment.isSame(moment(), 'day');
      };

      function isDateInThePast(date, time) {
        const slotDate = moment.tz(`${date} 00:00`, $scope.clinicTimezone).add(time, 'minutes');
        const maxDate = moment.tz($scope.clinicTimezone);

        return maxDate.isAfter(slotDate);
      }

      function isSlotUnavaiable(date, time, leadDays) {
        if (!leadDays) {
          return false;
        }

        const minDate = moment.tz($scope.clinicTimezone).add(leadDays, 'day');
        const slotDate = moment.tz(`${date} 00:00`, $scope.clinicTimezone).add(time, 'minutes');

        return !slotDate.isAfter(minDate);
      }

      $scope.getSlotStatusStyleClass = function(slot) {
        return 'slot-status-' + slot.status.toLowerCase();
      };

      $scope.getBlockStyleClass = function(block) {
        const styleClasses = [];
        const blockDate = block._date || block.startDate;
        const blockTime = block._startTime || block.startTime;

        if (isDateInThePast(blockDate, blockTime)) {
          styleClasses.push('past-event');
        } else if (block.available) {
          // We need to fetch the Provider from the scope object even if the block contains the provider object.
          // Reason being that the one in the scope gets updated if the days of notice changes.
          const provider = $scope.clinic.providers.find((p) => p.id === (block.provider.id || block.provider));

          if (isSlotUnavaiable(blockDate, blockTime, provider?.daysNoticeForAppointment)) {
            styleClasses.push('gray-scale');
          }
        }

        return styleClasses.join(' ');
      };

      $scope.getSlotStyleClass = function(slot) {
        const styleClasses = [$scope.getSlotStatusStyleClass(slot)];
        const slotTime = slot._startTime || slot.time;

        if (slot.hasAppointment) {
          styleClasses.push('clickable');
        } else if (isDateInThePast(slot.date, slotTime)) {
          styleClasses.push('past-event');
        } else {
          // We need to fetch the Provider from the scope object even if the slot contains the provider object.
          // Reason being that the one in the scope gets updated if the days of notice changes.
          const provider = $scope.clinic.providers.find((p) => p.id === slot.provider.id);

          if (isSlotUnavaiable(slot.date, slotTime, provider?.daysNoticeForAppointment)) {
            styleClasses.push('gray-scale');
          }
        }

        return styleClasses.join(' ');
      };

      $scope.removeAvailabilityBlock = function(availabilityBlock, event) {
        function del() {
          deleteAvailabilityBlock(availabilityBlock);

          var providerId = _.get(availabilityBlock.provider, 'id', availabilityBlock.provider);

          return ProviderAvailabilityBlockService.remove(providerId, availabilityBlock.id).catch(function() {
            // Restore the availability block if removal was unsuccessful.
            addAvailabilityBlocks([availabilityBlock]);
          });
        }

        if (event) {
          event.stopPropagation();
        }

        if (!availabilityBlock.recurring) {
          return del(availabilityBlock.id);
        } else if ($scope.showDeletePrompt) {
          $scope.blockToDelete = null;
          $scope.showDeletePrompt = false;
          return del(availabilityBlock.id);
        } else {
          if ($scope.showDeletePrompt) {
            return;
          }
          $scope.blockToDelete = availabilityBlock;
          $scope.showDeletePrompt = true;
        }
      };

      $scope.createAvailabilityBlockException = function(blockToDelete) {
        $scope.showDeletePrompt = false;
        $scope.blockToDelete = null;

        var momentObject = blockToMoment(blockToDelete);
        var date = momentObject.format(OpencareConstants.apiDateFormat);

        var exception = {
          providerAvailabilityBlock: blockToDelete.id,
          date: date,
        };

        var updatedBlockIndex = _.findIndex($scope.availabilityBlocks, function(availabilityBlock) {
          return availabilityBlock.id === blockToDelete.id;
        });

        $scope.availabilityBlocks[updatedBlockIndex].exceptions =
          $scope.availabilityBlocks[updatedBlockIndex].exceptions || [];
        $scope.availabilityBlocks[updatedBlockIndex].exceptions.push(exception);
        var index = $scope.availabilityBlocks[updatedBlockIndex].exceptions.length - 1;

        // TODO: add the loading state.
        return ProviderAvailabilityBlockService.createException(_.get(blockToDelete.provider, 'id', blockToDelete.provider), blockToDelete.id, momentObject.format(OpencareConstants.apiDateFormat)).then(function(exception) {
          _.merge($scope.availabilityBlocks[updatedBlockIndex].exceptions[index], exception);
          resetAvailabilityBlocks();
          repositionEvents(date);
        });
      };

      $scope.slotCanBeRemoved = function(slot) {
        return slot.status === OpencareConstants.reservedAppointmentSlotStatus.OPEN;
      };

      $scope.removeSlot = function(slot, event) {
        if (event) {
          event.stopPropagation();
        }

        deleteSlot(slot);

        var providerId = _.get(slot.provider, 'id', slot.provider);

        return ReservedAppointmentSlotService.remove(providerId, slot.id).then(function() {
          $scope.$emit('clinicReservedSlotsUpdated');
        })
          .catch(function() {
          // Restore the slot if removal was unsuccessful.
            addSlots([slot]);
          });
      };

      $scope.goToAppointment = function(slot, e) {
        if (!slot.appointment && !slot.appointmentId) {
          return;
        }
        if (e) {
          e.stopPropagation();
        }
        var state = $scope.modelType + '.appointment';

        $state.go(state, {
          tab: 'requests',
          page: 1,
          appointmentId: _.get(slot.appointment, 'id') || slot.appointmentId,
          backTo: 'Calendar',
        });
      };

      $scope.slotIsCreating = false;

      function createSlot(datetime) {
        if ($scope.slotIsCreating) {
          return $q.reject();
        }

        $scope.slotIsCreating = true;
        var providerId = _.get($scope.newEventOptions, 'provider.id') || $scope.filters.provider.id;
        var providerIds = [providerId];

        if ($scope.newEventOptions.provider === OpencareConstants.allProviders) {
          providerIds = _.map($scope.reservedSlotProviders, 'id');
        }

        providerIds = _.chain(providerIds).uniq()
          .compact()
          .value();

        if (!providerIds.length) {
          return $q.reject();
        }

        var date = datetime.format(OpencareConstants.apiDateFormat);
        var time = datetime.hours() * 60 + datetime.minutes();

        return ReservedAppointmentSlotService.create(providerIds, date, time).then(function(createdSlots) {
          $scope.$emit('clinicReservedSlotsUpdated');
          addSlots(createdSlots);
        })
          .finally(function() {
            $scope.slotIsCreating = false;
          });
      }

      $scope.availabilityBlockIsCreating = false;

      function createAvailabilityBlock(datetime, recurring, available, duration, isVacation) {
        if ($scope.availabilityBlockIsCreating) {
          return $q.reject();
        }

        $scope.availabilityBlockIsCreating = true;
        duration = duration || SLOT_DURATION_DEFAULT;
        var providerId = _.get($scope.newEventOptions, 'provider.id') || $scope.filters.provider.id;
        var startDate = datetime.format(OpencareConstants.apiDateFormat);
        var startTime = datetime.hours() * 60 + datetime.minutes();
        var endTime = datetime.hours() * 60 + datetime.minutes() + duration;
        var type = isVacation
          ? OpencareConstants.providerAvailabilityBlock.types.VACATION
          : OpencareConstants.providerAvailabilityBlock.types.DEFAULT;

        if ($scope.newEventOptions.provider === OpencareConstants.allProviders) {
          return ProviderAvailabilityBlockService.createForClinic(
            $scope.clinic.id,
            startDate,
            startTime,
            endTime,
            available,
            recurring,
            type,
          ).then(function(createdAvailabilityBlocks) {
            addAvailabilityBlocks(createdAvailabilityBlocks);
          })
            .finally(function() {
              $scope.availabilityBlockIsCreating = false;
            });
        }

        return ProviderAvailabilityBlockService.create(
          providerId,
          startDate,
          startTime,
          endTime,
          available,
          recurring,
          type,
        ).then(function(createdAvailabilityBlock) {
          addAvailabilityBlocks([createdAvailabilityBlock]);
        })
          .finally(function() {
            $scope.availabilityBlockIsCreating = false;
          });
      }

      function createAvailabilityBlockOfVacationType(datetime) {
        return createAvailabilityBlock(moment(datetime).startOf('day'), false, false, 1440, true);
      }

      function hideAddEvent() {
        getElement('#js-calendar-add').hide();
      }

      function createSlotFromEvent(event) {
        var datetime = coordinateToMoment(event.pageX, event.pageY);

        if (!datetime || !isValidAddMoment(datetime)) {
          return false;
        }

        return createSlot(datetime).then(hideAddEvent);
      }

      function releaseDragTimeslot(e) {
        var addEventMoment = coordinateToMoment(e.pageX, e.pageY);

        if (!addEventMoment) {
          clearDragSlot(e);
          return;
        }

        if (!isValidAddMoment(addEventMoment, $scope.draggingEvent)) {
          return clearDragSlot(e);
        }

        var event = _.assign({}, $scope.draggingEvent);
        if ($scope.getEventType(event) === 'slot') {
          var currentSlotMoment = slotToMoment($scope.draggingEvent);
          if (addEventMoment.isSame(currentSlotMoment)) {
            clearDragSlot(e);
          } else {
            $scope.newEventOptions.provider = _.get(event, 'provider') || $scope.filters.provider;
            createSlot(addEventMoment);
            $scope.removeSlot(event);
            clearDragSlot(e);
          }
        } else if ($scope.getEventType(event) === 'available-block') {
          var availableBlockMoment = blockToMoment($scope.draggingEvent);
          if (addEventMoment.isSame(availableBlockMoment)) {
            clearDragSlot(e);
          } else {
            $scope.newEventOptions.provider = _.get(event, 'provider') || $scope.filters.provider;
            createSlot(addEventMoment, false, true);
            clearDragSlot(e);
            $scope.createAvailabilityBlockException(event);
          }
        } else if ($scope.getEventType(event) === 'unavailable-block') {
          var unavailableBlockMoment = blockToMoment($scope.draggingEvent);
          if (addEventMoment.isSame(unavailableBlockMoment)) {
            clearDragSlot(e);
          } else {
            var length = event.endTime - event.startTime;
            $scope.newEventOptions.provider = _.get(event, 'provider') || $scope.filters.provider;
            createAvailabilityBlock(addEventMoment, false, false, length);
            clearDragSlot(e);
            if (event.recurring) {
              $scope.createAvailabilityBlockException(event);
            } else {
              $scope.removeAvailabilityBlock(event);
            }
          }
        }
      }

      function addSlots(slots) {
        _.each(slots, function(slot) {
          slot.displayId = slot.displayId || slot.id;
          slot._weekDayIndex = _.isNumber(slot._weekDayIndex) ? slot._weekDayIndex : moment(slot.date).day();
          $scope.slots.push(slot);
          $scope.slotsByDay[getDayIndex(slot._weekDayIndex)].push(slot);
        });

        var dates = _.chain(slots).map('date')
          .uniq()
          .value();

        repositionEvents(dates.length === 1 ? dates[0] : null);
      }

      function addAvailabilityBlocks(availabilityBlocks) {
        _.each(availabilityBlocks, function(availabilityBlock) {
          availabilityBlock.displayId = availabilityBlock.displayId || availabilityBlock.id;
          availabilityBlock._weekDayIndex = _.isNumber(availabilityBlock._weekDayIndex)
            ? availabilityBlock._weekDayIndex
            : moment(availabilityBlock.startDate).day();
          $scope.availabilityBlocks.push(availabilityBlock);
        });
        resetAvailabilityBlocks();

        var dates = _.chain(availabilityBlocks).map('startDate')
          .uniq()
          .value();

        repositionEvents(dates.length === 1 ? dates[0] : null);
      }

      function deleteSlot(slot) {
        slot._weekDayIndex = _.isNumber(slot._weekDayIndex) ? slot._weekDayIndex : moment(slot.date).day();

        _.remove($scope.slots, function(_slot) {
          return String(_slot.id) === String(slot.id);
        });
        _.remove($scope.slotsByDay[getDayIndex(slot._weekDayIndex)], function(_slot) {
          return String(_slot.id) === String(slot.id);
        });

        repositionEvents(slot.date);
      }

      function deleteAvailabilityBlock(availabilityBlock) {
        availabilityBlock._weekDayIndex = _.isNumber(availabilityBlock._weekDayIndex)
          ? availabilityBlock._weekDayIndex
          : moment(availabilityBlock.startDate).day();

        _.remove($scope.availabilityBlocks, function(_availabilityBlock) {
          return String(_availabilityBlock.id) === String(availabilityBlock.id);
        });
        resetAvailabilityBlocks();

        repositionEvents(availabilityBlock.startDate);
      }

      function positionAvailabilityBlock(availabilityBlock) {
        // $timeout is used to guarantee that slot adding and CSS calculations
        // do not happen in the same Angular digest loop.
        $timeout(function() {
          if (availabilityBlock._hour === undefined) {
            availabilityBlock._hour = moment().startOf('year')
              .add(availabilityBlock.startTime, 'minutes')
              .hour();
          }

          var availabilityBlockHour = availabilityBlock._hour;
          var availability = availabilityBlock.available ? 'available' : 'unavailable';
          var availabilityBlockEl = getElement('#js-calendar-' + availability + '-block-' + availabilityBlock.id);
          var availabilityBlockChildEl = getElement('#js-calendar-' + availability + '-block-' + availabilityBlock.id + ' .calendar-event');
          var hourEl = getElement('#js-calendar-hour-' + availabilityBlockHour);
          var minuteOffset = (availabilityBlock.startTime - availabilityBlockHour * 60) / 60 * hourEl.height();
          var headerEl = getElement('#js-calendar-header');
          var scrollAreaEl = getElement('#js-calendar-scroll-area');
          var heightInPixels = EVENT_CSS_OUTER_CELL_HEIGHT_TO_MINUTES_RATIO
            * (availabilityBlock.endTime - availabilityBlock.startTime);
          var rootElOffset = element.offset();

          var availabilityBlockCss = {
            // Vertical position in the day column.
            top: hourEl.offset().top
              - rootElOffset.top
              + minuteOffset
              - headerEl.outerHeight()
              + scrollAreaEl.scrollTop(),
          };
          var availabilityBlockChildCss = {
            // Height based on the availability block duration.
            height: Math.max(EVENT_CSS_OUTER_CELL_HEIGHT_PX, heightInPixels) - EVENT_CSS_OUTER_PADDING_PX,
          };

          var availabilityBlockConcurrencyData = getConcurrencyData(availabilityBlock);

          if (availabilityBlockConcurrencyData.count > 0) {
            var availabilityBlockWidth = EVENT_CSS_WIDTH_PCT / availabilityBlockConcurrencyData.crossedCount;
            var availabilityBlockLeft = availabilityBlockWidth * availabilityBlockConcurrencyData.index;

            // Horizontal position among concurrent events.
            availabilityBlockCss.width = availabilityBlockWidth + '%';
            availabilityBlockCss.left = availabilityBlockLeft + '%';
          }

          availabilityBlockEl.css(availabilityBlockCss);
          availabilityBlockChildEl.css(availabilityBlockChildCss);
        });
      }

      function positionSlot(slot) {
        // $timeout is used to guarantee that slot adding and CSS calculations
        // do not happen in the same Angular digest loop.
        $timeout(function() {
          if (slot._hour === undefined) {
            slot._hour = moment().startOf('year')
              .add(slot.time, 'minutes')
              .hour();
          }

          const slotHour = slot._hour;
          const slotEl = getElement('#js-calendar-slot-' + slot.displayId);
          const hourEl = getElement('#js-calendar-hour-' + slotHour);
          const minuteOffset = (slot.time - slotHour * 60) / 60 * hourEl.height();
          const headerEl = getElement('#js-calendar-header');
          const scrollAreaEl = getElement('#js-calendar-scroll-area');
          const rootElOffset = element.offset();

          const heightPerMinute = EVENT_CSS_OUTER_CELL_HEIGHT_TO_MINUTES_RATIO;
          const slotDuration = SLOT_DURATION_DEFAULT;

          var slotCss = {
            // Vertical position in the day column.
            top: hourEl.offset().top
              - rootElOffset.top
              + minuteOffset
              - headerEl.outerHeight()
              + scrollAreaEl.scrollTop(),
            height: (heightPerMinute * slotDuration) - 1,
          };

          const slotConcurrencyData = getConcurrencyData(slot);

          if (slotConcurrencyData.count > 0) {
            const slotWidth = EVENT_CSS_WIDTH_PCT / slotConcurrencyData.crossedCount;
            const slotLeft = slotWidth * slotConcurrencyData.index;

            // Horizontal position among concurrent events.
            slotCss.width = slotWidth + '%';
            slotCss.left = slotLeft + '%';
          }

          slotEl.css(slotCss);
        });
      }

      $scope.isPrevPeriodAvailable = function() {
        var newDate = moment($scope.filters.dateGte).subtract(CALENDAR_DAYS_NUM, 'days');
        return newDate.isSameOrAfter(moment().startOf('week'), 'day');
      };

      $scope.nextPeriod = function() {
        var newDate = moment($scope.filters.dateGte).add(CALENDAR_DAYS_NUM, 'days');
        $scope.filters.dateGte = newDate.format(OpencareConstants.apiDateFormat);
        $scope.onReload();
      };

      $scope.prevPeriod = function() {
        if (!$scope.isPrevPeriodAvailable()) {
          return;
        }
        var newDate = moment($scope.filters.dateGte).subtract(CALENDAR_DAYS_NUM, 'days');
        $scope.filters.dateGte = newDate.format(OpencareConstants.apiDateFormat);
        $scope.onReload();
      };

      $scope.blockOfVacationType = function(block) {
        return block.type === OpencareConstants.providerAvailabilityBlock.types.VACATION;
      };

      $scope.blockIsAutoGenerated = function(block) {
        return SYSTEM_BLOCK_METADATA_KEYS.some(function(key) {
          return !!(block.metadata && block.metadata[key]);
        });
      };

      $scope.shouldDisplayCurrentTimeIndicator = function() {
        const currentTime = moment.tz($scope.clinicTimezone).format('YYYY-MM-DD');
        return currentTime >= $scope.filters.dateGte && currentTime < $scope.filters.dateLt;
      };

      $scope.getCurrentTimeIndicatorOffset = function() {
        const cells = document.getElementsByClassName('day-cell');
        if (!cells || cells.length === 0) {
          return;
        }

        const cellWidth = cells[0].clientWidth;
        const indicatorWidth = cellWidth + CALENDAR_INDICATOR_OFFSET;

        const currentTime = moment.tz($scope.clinicTimezone);
        const startOfDay = currentTime.clone().startOf('day');

        const dow = currentTime.day();
        const indicatorLeft = EVENT_CSS_OUTER_CELL_WIDTH_SMALL_PX + cellWidth * dow - CALENDAR_INDICATOR_OFFSET + 1;

        const diff = currentTime.diff(startOfDay, 'minutes');
        const row = diff / 30; // Each row/cell represents 30 minutes
        const indicatorTop = row * EVENT_CSS_OUTER_CELL_HEIGHT_PX;

        return {
          width: `${indicatorWidth}px`,
          left: `${indicatorLeft}px`,
          top: `${indicatorTop}px`,
        };
      };
    },
  };
});
